require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
module.exports = require('../modules/_core').Promise;


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/core-js/fn/promise.js
// module id = 79
// module chunks = 1